import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStore2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeWidth=".6"
      d="M4.879 10.494a3.19 3.19 0 0 0 2.595-1.336 3.097 3.097 0 0 0 5.09.006 3.181 3.181 0 0 0 2.587 1.33c2.043 0 3.587-1.98 3.088-3.96l-.974-3.867a1.32 1.32 0 0 0-1.28-.997H4.008c-.606 0-1.133.41-1.281.998L1.76 6.51c-.276 1.096.087 2.051.728 2.92v7.58c0 .728.587 1.32 1.316 1.32h12.39c.729 0 1.316-.592 1.316-1.32v-4.915a.586.586 0 0 0-.587-.578.586.586 0 0 0-.587.578v4.915c0 .091-.05.18-.142.18h-3.632v-4.508a.582.582 0 0 0-.578-.582h-3.97a.582.582 0 0 0-.578.582v4.509H3.804c-.091 0-.141-.09-.141-.18v-6.76a3.05 3.05 0 0 0 1.216.243Zm8.253-7.685h2.853c.075 0 .141.06.16.132l.973 3.87c.317 1.257-.663 2.526-1.962 2.526a2.025 2.025 0 0 1-2.024-2.027v-4.5Zm-5.055 0h3.916V7.31c0 1.087-.85 2.03-1.96 2.03-1.128 0-1.956-.953-1.956-2.048V2.809Zm.534 10.466h2.777v3.916H8.61v-3.916ZM2.88 6.792l.967-3.85a.172.172 0 0 1 .16-.133h2.894v4.483a2.045 2.045 0 0 1-2.04 2.047c-1.313 0-2.302-1.274-1.982-2.547Z"
    />
  </svg>
);
export default SvgStore2;
